module.exports = __webpack_public_path__ + "static/media/codes-sprint-demo.f6520ce6.gif";